import { FC } from "react";
import css from './index.module.css';
import Menu from "./menu";

interface MainContent {
  children: any;
  header: string | null;
}

const MainContent: FC<MainContent> = ({ header, children }) => {
  return (
    <div className={css.kit}> 
      <div className={css.kit_body} id="main-content">
        <div className={css.kit_body_contentnCover} id="scrollable-content">
          {header != null && header != 'n' && <h1 className={css.head}>{header}</h1> }
          {header === null && <h1 style={{ paddingBottom: 20 }} />}
          {children}
        </div>
      </div>

      <Menu />
    </div>
  );
};

export default MainContent;